import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/accounts`;

export const draws = {
  getAll: async ({ accountId, sort } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/draws`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      sort,
    });
    return apiRequest(options);
  },
  get: async ({ accountId, drawId } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/draws/${drawId}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  update: async ({ accountId, data, params, toastMessageConfig } = {}) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${accountId}/draws`,
      method: "put",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
      params,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
